import { combineReducers } from 'redux';

import { filtersReducer } from './filters/filters.reducer';
import { mainViewDataReducer } from './MainViewData/mainViewData.reducer';

export const containerReducer = combineReducers({
  filters: filtersReducer,
  mainViewData: mainViewDataReducer,
});
